import { useQuery } from '@apollo/client';

import { PRODUCT_AVAILABLE_SIZES } from '../queries';
import usePDPApolloQueryVariables from '../usePDPApolloQueryVariables';

const useProductAvailableSizes = (id, slug) => {
  const { variables, skip } = usePDPApolloQueryVariables(id, slug);
  const { loading, error, data, refetch } = useQuery(PRODUCT_AVAILABLE_SIZES, {
    variables,
    skip,
    context: { noBatch: true },
  });
  return {
    loading: loading || skip,
    error,
    data: data?.availableSizes,
    refetch,
  };
};

export default useProductAvailableSizes;
